import { RefObject, useEffect } from 'react';

/**
 * Hook that alerts clicks if scrolled outside of the ref element
 */
export const useOnScroll = (refs: RefObject<HTMLDivElement | null>[], callback: () => void) => {
  useEffect(() => {
    function handleScroll(event: Event) {
      const target = event.target as Node;
      const scrolledOnRef = refs
        .map((ref) => ref.current && ref.current.contains(target))
        .includes(true);
      if (target && !scrolledOnRef) {
        callback?.();
      }
    }
    document.addEventListener('scroll', handleScroll, true);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refs]);
};
